<template>
  <div class="card mt-2 mb-2 ms-5 me-5">
    <div class="card-body">
      <h4><strong>Especificaciones de la materia prima</strong></h4>
      <div class="table-responsive">
        <table class="mx-auto">
          <tbody>
            <tr>
              <td class="lblform"><strong>Presentación / Norma / Acabado:</strong></td>
              <td colspan="5">
                <select id="tubeSpecification" class="form-select avilable-input" v-model="tube"
                  @change="getParameters(tube)">
                  <option selected>Opciones disponibles...</option>
                  <option v-for="tubeAv in avilableTubes" :key="tubeAv.id" v-bind:value="tubeAv">
                    {{ tubeAv }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>Nombre Comercial:</strong></td>
              <td colspan="5">
                <select id="tubeTradeName" class="form-select avilable-input" v-model="tradeName"
                  @change="getTubeId(tradeName)">
                  <option selected>Opciones disponibles...</option>
                  <option v-for="tubeType in tubeTypesByTradeName" :key="tubeType.id" v-bind:value="tubeType.tube_id">
                    {{ tubeType.tube_trade_name }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>Nombre técnico: </strong></td>
              <td colspan="5" class="inputForm">
                <input id="tubeTechnicalName" class="form-control" type="text" readonly v-model="technicalName" />
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>{{ heigthLabel }}: </strong></td>
              <td colspan="2" class="inputForm">
                <input id="tubeHeight" class="form-control" type="number" readonly v-model="heigthValue" /><i>mm.</i>
              </td>
              <td v-show="!flagNoneWidthLabel" class="lblform"><strong>{{ widthLabel }}: </strong></td>
              <td colspan="2" v-show="!flagNoneWidthLabel" class="inputForm">
                <input id="tubeWingWidth" class="form-control" type="number" readonly v-model="widthValue" /><i>mm.</i>
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>{{ thicknessLabel }}: </strong></td>
              <td class="inputForm">
                <input id="tubeThinckness" class="form-control" type="number" readonly
                  v-model="thicknessValue" /><i>mm.</i>
              </td>
              <td class="lblform"><strong>Peso por metro: </strong></td>
              <td class="inputForm">
                <input id="tubeWeigthMeter" class="form-control" type="number" readonly
                  v-model="weightMeterValue" /><i>kg.</i>
              </td>
              <td class="lblform">
                <strong>Precio por kilo del perfil:</strong>
              </td>
              <td class="inputForm">
                <input type="number" readonly class="form-control" id="tubeKiloPrice" v-model="tubeKiloPrice"
                  @change="sendKiloPrice()" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  props: {
    getImgInfo: Object,
  },
  watch: {
    getImgInfo(newVal) {
      if (newVal !== null) {
        this.defineTubeNameByImg();
      }
    },
  },
  data() {
    return {
      //Nombre y id de la materia prima principal
      //Según el id de esa materia prima principal se hace una búsqueda de los perfiles disponibles
      rawMatName: "",
      tubeNameByImg: "",
      rawMatId: 0,
      avilableTubes: [],
      //Selecinar tipo de perfil requerida y con los parámetros tubePresnetation y tubeSpecification realizar búsqueda
      tubePresentation: "",
      tubeSpecification: "",
      tubeKiloPrice: 0,
      //Select 2
      //Nombres comerciales disponibles para el perfil seleccionado
      tubeTypesByTradeName: [],
      tubeFinalId: 0,
      //Etiquetas para espesor y espesor de ala
      widthLabel: "",
      heigthLabel: "",
      thicknessLabel: "",
      flagNoneWidthLabel: false,
      //Informacion del perfil seleccioando
      tubeTypeInfo: [],
      technicalName: "",
      heigthValue: 0,
      widthValue: 0,
      thicknessValue: 0,
      weightMeterValue: 0,
      //Dimensions or diametre variable
      heigth: 0,
      width: 0,
      diameter: 0,
    }
  },
  methods: {
    validateRawMatName(rawName) {
      if (rawName === "ESTRUCTURAL") {
        this.rawMatId = 9;
        return true;
      } else if (rawName === "MUEBLE") {
        this.rawMatId = 10;
        return true;
      } else {
        this.rawMatId = 0;
        return false;
      }
    },
    getParameters(option) {
      //console.log(option);
      if (option != "") {
        const parts = option.split(" / ");
        this.tubePresentation = parts[0].trim();
        this.tubeSpecification = parts[1].trim();
        //console.log(this.tubePresentation);
        //console.log(this.tubeSpecification);
      } else {
        alert("Por favor, seleccione una opcion válida");
      }
      this.searchTubesByParameters();
    },
    async searchTubesByParameters() {
      if (this.tubePresentation === "" || this.tubeSpecification === "") {
        console.log("Materia prima no selecionada");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/tube/list", {
            params: {
              tube_name: this.tubePresentation,
              tube_specification: this.tubeSpecification,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            //console.log(res.data[0]);
            this.heigthLabel = res.data[0].heightLabel;
            this.widthLabel = res.data[0].widthLabel;
            // Establecer flagNoneWidthLabel basado en el valor de widthLabel
            this.flagNoneWidthLabel = this.widthLabel === "no_aplica";
            this.thicknessLabel = res.data[0].thicknessLabel;
            this.tubeKiloPrice = res.data[0].priceId["value"];
            this.$emit("sendKiloPrice", this.tubeKiloPrice);
            const tubeTypes = res.data[0].tubeTypes;
            // Crear un nuevo array clave-valor (id, nombreComercial)
            this.tubeTypesByTradeName = tubeTypes.map((tubeType) => {
              return {
                tube_id: tubeType.id,
                tube_trade_name: tubeType.tradeName,
                // Puedes agregar más propiedades según sea necesario
              };
            });
            // Mostrar el nuevo array en la consola
            //console.log(this.tubeTypesByTradeName);
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    getTubeId(option) {
      // console.log("Tube Id Type: " + option);
      this.tubeFinalId = option;
      this.getInfoTubeType();
    },
    async getInfoTubeType() {
      if (this.tubeFinalId == 0) {
        console.log("Tubo no selecionado");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/tube/type/get", {
            params: {
              tube_type_id: this.tubeFinalId,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            this.tubeTypeInfo = res.data[0];
            console.log(this.tubeTypeInfo);
            this.technicalName = this.tubeTypeInfo.technicalName;
            let dimensionsOrDiameter = this.tubeTypeInfo.diameterOrDimensionMm;
            if (dimensionsOrDiameter.includes("X")) {
              var dimensions = dimensionsOrDiameter.split("X");
              this.heigth = parseFloat(dimensions[0].replace(',', '.').trim());
              this.width = parseFloat(dimensions[1].replace(',', '.').trim());
              // console.log("Altura:", heigth);
              // console.log("Ancho:", width);
            } else {
              this.diameter = parseFloat(dimensionsOrDiameter);
              // console.log("Diámetro:", diameter);
            }

            this.heigthLabel === "Diámetro exterior" ? this.heigthValue = this.diameter : this.heigthValue = this.heigth;
            this.widthLabel !== "no_aplica" ? this.widthValue = this.width : this.widthValue = 0;
            this.thicknessValue = this.tubeTypeInfo.thicknessWall;
            this.weightMeterValue = this.tubeTypeInfo.weightMeter;
            this.$emit("sendMainTubeTypeIdAndWeigthMeter", { tubeTypeId: this.tubeFinalId, weightMeter: this.weightMeterValue });
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    defineTubeNameByImg() {
      this.tubeNameByImg = this.getImgInfo.imgFormName;
      console.log(this.tubeNameByImg);
      let tubeUpperImgName = this.tubeNameByImg.toUpperCase();
      console.log(tubeUpperImgName);
      if (this.validateRawMatName(this.rawMatName) && tubeUpperImgName != "") {
        console.log("Id de mat:" + this.rawMatId);
        axios
          .get(RUTA_SERVIDOR + "api/tube/list", {
            params: {
              tube_name: tubeUpperImgName,
              tube_raw_material: this.rawMatId,
            },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
          //.then((res) => (console.log(res.data)))
          .then((res) => {
            //console.log(res.data[0]);
            // Aquí colocas el código para eliminar los valores repetidos
            const uniqueTubes = new Set();
            res.data.forEach((avilableTube) => {
              // Reemplazar "/" por "-"
              //const specificationText = aviableTube.specification.replace(/\//g, "-");
              const tubeText = `${avilableTube.name} / ${avilableTube.specification}`;
              uniqueTubes.add(tubeText);
            });
            this.avilableTubes = Array.from(uniqueTubes);
          })
          .catch((err) => console.log(`There has been an error ${err}`));
      } else {
        console.log("Nombre de familia no válido");
      }
    },
  },
  mounted() {
    this.rawMatName = this.$store.getters.getRawMatFamily;
    // console.log(this.rawMatName);
  },
};
</script>
<style scoped>
.card {
  border: solid 2px #a6323b;
}

input [type="number"] {
  padding: 2px 6px 2px 16px;
  border: solid 5px #999999;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.avilable-input {
  background-color: #FCE196;
}
</style>